import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export const formatDate = (date: Date | number) => {
	return new Intl.DateTimeFormat("en-US", { dateStyle: "medium" }).format(date);
};

export const formatMoney = (amount: number, currency: string) =>
	new Intl.NumberFormat("en-US", {
		style: "currency",
		currency,
	}).format(amount);

export const formatMoneyRange = (
	range: {
		start?: { amount: number; currency: string } | null;
		stop?: { amount: number; currency: string } | null;
	} | null,
) => {
	const { start, stop } = range || {};
	const startMoney = start && formatMoney(start.amount, start.currency);
	const stopMoney = stop && formatMoney(stop.amount, stop.currency);

	if (startMoney === stopMoney) {
		return startMoney;
	}

	return `${startMoney} - ${stopMoney}`;
};

export function getHrefForVariant({
	productSlug,
	variantId,
}: {
	productSlug: string;
	variantId?: string;
}): string {
	const pathname = `/products/${encodeURIComponent(productSlug)}`;

	if (!variantId) {
		return pathname;
	}

	const query = new URLSearchParams({ variant: variantId });
	return `${pathname}?${query.toString()}`;
}

type dscObj = {
	data: { text: string };
	type: string;
};
type dscList = {
	blocks: dscObj[];
};
export const filterDsc = (dsc: string) => {
	const dscObj = JSON.parse(dsc) as dscList;
	let des = "";
	if (dscObj && dscObj.blocks.length > 0) {
		des = dscObj.blocks[0].data.text;
	}

	return des;
};

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}



// 提取youtube视频链接
export const getYoutubeLink = (url: string) => {
	const reg = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
	const match = url.match(reg);
	return match && match[7].length === 11 ? match[7] : "";
};


// 设置html的overflow
export function setOverflow(overflow: string) {
	document.documentElement.style.overflow = overflow;
  }


  export function convertPriceToNumber(priceString: string): number {
    if (!priceString) return 0;
    if (isNaN(+priceString[0])) {
      priceString = priceString.replace(/[^0-9.]/g, "");
    }
  
    return parseFloat(priceString);
  }
  
  export function formatPrice(price: string) {
    const newPrice = convertPriceToNumber(price);
    return newPrice.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  // 防抖函数
export function debounce(fn: Function, delay: number) {
  let timer: any = null;
  return (...args: any[]) => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      // @ts-ignore
      fn.apply(this, args);
    }, delay);
  };
}

